// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.05);
}

.invoice-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}

.invoice-row {
  margin-bottom: 12px;
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin-bottom: 4px;
}

.company-name {
  color: #000000;
}

.invoice-count {
  font-weight: 600;
  color: #6b7280;
}

.progress-bar {
  width: 100%;
  height: 6px;
  background: #eef2f7;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg,#7dd3fc,#22c55e);
  border-radius: 4px;
  transition: width 0.4s ease;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ap_auto_app/Charts/CompanyInvoiceList.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kDAAkD;EAClD,kBAAkB;EAClB,2BAA2B;AAC7B","sourcesContent":[".invoice-card {\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 16px;\n  box-shadow: 0 3px 10px rgba(0,0,0,0.05);\n}\n\n.invoice-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.invoice-row {\n  margin-bottom: 12px;\n}\n\n.invoice-header {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  margin-bottom: 4px;\n}\n\n.company-name {\n  color: #000000;\n}\n\n.invoice-count {\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 6px;\n  background: #eef2f7;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg,#7dd3fc,#22c55e);\n  border-radius: 4px;\n  transition: width 0.4s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
